import { FormikHelpers } from "formik";
import { useGetUsedBy } from "./api/getUsedBy";
import UsedByTypeForm from "./UsedByForm";
import { useEditUsedBy } from "./api/editUsedBy";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditUsedBy = ({handleCloseModal, usedById}: EditUsedByProps)  => {
  const getUsedByQuery = useGetUsedBy({usedById: usedById})
  const editUsedByMutation = useEditUsedBy({data: {}, usedById});

  const handleSubmit = async (values: IPostEditUsedBy, { setSubmitting }: FormikHelpers<IPostEditUsedBy>): Promise<void> => {
    try {
      await editUsedByMutation.mutateAsync({
        data: values,
        usedById: usedById
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getUsedByQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getUsedByQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της παράμετρου 'Χρήση από'</div>
    )
  }

  return (
    <>
      {!getUsedByQuery.isLoading && getUsedByQuery.data &&
        <UsedByTypeForm initialValues={getUsedByQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditUsedByProps {
  usedById: number;
  handleCloseModal: () => void;
}

export default EditUsedBy;